import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)
const files = require.context("./modules", false, /\.js$/)
const modules = {
  getters: {},
  state: {},
  mutations: {},
  actions: {}
}

files.keys().forEach((key) => {
  Object.assign(modules.getters, files(key)["getters"])
  Object.assign(modules.state, files(key)["state"])
  Object.assign(modules.mutations, files(key)["mutations"])
  Object.assign(modules.actions, files(key)["actions"])
})
const store = new Vuex.Store(modules)
export default store